export const MODAL_QUERY = "modal"

export function buildModalSearch(
  current: string,
  name: string,
  params?: Record<string, string>
): string {
  const qs = new URLSearchParams(current)
  qs.set(MODAL_QUERY, name)
  for (const [key, value] of Object.entries(params ?? {})) {
    qs.set(key, value)
  }
  return qs.toString()
}

// Changes the params of an already open modal. Unlike buildModalSearch this
// deletes a key passed as undefined: moving to another tab has to drop the
// params that only made sense under the previous one.
// MODAL_QUERY is off limits — swapping the modal through here would skip
// isModalName and the openedByApp bookkeeping that Back and Escape depend on.
// Changing which modal is open goes through openUrlModal / closeUrlModal.
export function buildModalParamsSearch(
  current: string,
  params: Record<string, string | undefined>
): string {
  const qs = new URLSearchParams(current)
  for (const [key, value] of Object.entries(params)) {
    if (key === MODAL_QUERY) continue
    if (value === undefined) qs.delete(key)
    else qs.set(key, value)
  }
  return qs.toString()
}

export function hasModalQuery(current: string): boolean {
  return new URLSearchParams(current).has(MODAL_QUERY)
}

// ownKeys are the params the modal itself put in the query. Closing has to
// take them with it, otherwise a deep link leaves `?tab=deposit` behind on the
// page underneath. Params that belong to the page (`?page=2`) stay.
export function stripModalSearch(
  current: string,
  ownKeys: readonly string[] = []
): string {
  const qs = new URLSearchParams(current)
  qs.delete(MODAL_QUERY)
  for (const key of ownKeys) qs.delete(key)
  return qs.toString()
}

export function modalPropsFromSearch(current: string): Record<string, string> {
  return Object.fromEntries(
    [...new URLSearchParams(current).entries()].filter(
      ([key]) => key !== MODAL_QUERY
    )
  )
}
